<template>
  <div class="truth-declaration-content">
    <h3 class="title has-text-centered">
      Declaração Digital de Veracidade e Responsabilidade das Informações Cadastrais
    </h3>

    <div class="declaration-text">
      <p>
        Eu, <strong>{{ user.nome }}</strong
        >, inscrito(a) no CPF nº <strong>{{ user.cpf }}</strong
        >, na qualidade de representante e/ou usuário autorizado da empresa
        <strong>{{ company.socialDenomination }}</strong
        >, inscrita no CNPJ nº <strong>{{ company.cnpj }}</strong
        >, DECLARO, para todos os fins de direito, que:
      </p>

      <h6 class="subtitle is-6">Veracidade das informações</h6>
      <p>
        Todas as informações prestadas por mim no cadastro da plataforma Selcorp Licitações —
        incluindo dados digitados manualmente e dados apresentados por integração automatizada com
        bases oficiais — são verdadeiras, completas, atuais e corretas na data e hora desta
        declaração.
      </p>

      <h6 class="subtitle is-6">Revisão e conferência (etapa concluída)</h6>
      <p>
        Declaro que realizei a conferência integral de todos os dados exibidos no cadastro,
        incluindo os dados preenchidos manualmente e os dados retornados pela integração
        automatizada, e que corrigi previamente quaisquer divergências identificadas. Assim,
        confirmo como corretas as informações que permanecem registradas na plataforma no momento do
        envio/salvamento, assumindo total responsabilidade por seu conteúdo.
      </p>

      <h6 class="subtitle is-6">Responsabilidade legal e consequências</h6>
      <p>
        Tenho ciência de que a inserção, confirmação ou manutenção de informações falsas,
        incompletas, desatualizadas ou incompatíveis com a realidade poderá acarretar, a critério da
        Selcorp e/ou por determinação legal:
      </p>
      <ul>
        <li>• suspensão, bloqueio ou cancelamento do cadastro e do acesso à plataforma;</li>
        <li>• impedimento de utilização de funcionalidades e/ou participação em processos;</li>
        <li>
          • responsabilização civil, administrativa e penal, nos termos da legislação aplicável.
        </li>
      </ul>

      <h6 class="subtitle is-6">Documentos e comprovação</h6>
      <p>
        Comprometo-me a apresentar documentos comprobatórios sempre que solicitado(a), inclusive
        para validação de dados societários, cadastrais, fiscais e de endereço, e autorizo que a
        Selcorp realize verificações de consistência cadastral por meios eletrônicos, para fins de
        segurança, conformidade e prevenção a fraudes.
      </p>

      <h6 class="subtitle is-6">Autorização e poderes para declarar</h6>
      <p>
        Declaro possuir legitimidade, poderes e autorização para prestar as informações e aceitar
        esta declaração em nome da empresa indicada, responsabilizando-me integralmente por qualquer
        questionamento futuro quanto à veracidade das informações e/ou à legitimidade deste ato.
      </p>

      <h6 class="subtitle is-6">Aceite eletrônico e evidências técnicas</h6>
      <p>
        Reconheço e concordo que este aceite constitui declaração digital válida, equivalente a
        instrumento assinado, produzindo efeitos jurídicos. Autorizo, ainda, que a Selcorp registre
        e armazene evidências técnicas do aceite e do ato de finalização do cadastro, incluindo,
        entre outros: IP, data, horário, identificador do usuário e logs de auditoria.
      </p>

      <p>
        Por ser expressão da verdade, confirmo eletronicamente esta declaração para finalização do
        cadastro.
      </p>

      <div class="declaration-footer mt-5">
        <p>Data/hora: {{ currentDateTime }}</p>
        <p>Usuário: {{ user.nome }} - {{ user.email }}</p>
        <p>Empresa: {{ company.cnpj }} - {{ company.socialDenomination }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyTruthDeclaration',
  props: {
    user: {
      type: Object,
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
    currentDateTime: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.truth-declaration-content {
  background-color: white;
  padding: 1rem;

  .declaration-text {
    font-size: 0.95rem;
    line-height: 1.6;
    text-align: justify;

    p {
      margin-bottom: 1.2rem;
    }

    ul {
      margin-left: 1.5rem;
      margin-bottom: 1.2rem;

      li {
        margin-bottom: 0.6rem;
      }
    }

    .subtitle {
      font-size: 1.1rem;
      font-weight: 600;
      margin: 1.5rem 0 0.8rem;
    }
  }

  .declaration-footer {
    border-top: 1px solid #eee;
    padding-top: 1rem;
    font-style: italic;
    color: #666;

    p {
      margin-bottom: 0.3rem;
    }
  }
}
</style>
